import ajax from '@/libs/api.request'
export default {
  //获取所有时间段
  getTimeList:param=>{
    return ajax.get('edu/web/setting/getTimeList');
  },
  //保存时间段
  saveTime:param=>{
    return ajax.post('edu/web/setting/saveTime',param);
  },
  //删除时间段
  delTime:param=>{
    return ajax.post('edu/web/setting/delTime',param);
  },
  //获取所有假期
  getVacList:param=>{
    return ajax.get('edu/web/setting/getVacList');
  },
  //保存假期
  saveVac:param=>{
    return ajax.post('edu/web/setting/saveVac',param);
  },
  //删除假期
  delVac:param=>{
    return ajax.post('edu/web/setting/delVac',param);
  },
    loadNotifySetting:param=>{
        return ajax.get('edu/web/setting/loadNotifySetting',param);
    },
    saveNotifySetting:param=>{
        return ajax.post('edu/web/setting/saveNotifySetting',param);
    },
}
